
































































import { NakaCompanyConfiguration } from '@/store/interfaces/company';
import companyType from '@/store/types/company';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import NakaBinding from './forms/NakaBinding.vue';

export default Vue.extend({
  name: 'ProfileNaka',
  components: {
    NakaBinding,
  },
  data: () => ({
    edit: false,
  }),
  computed: {
    ...mapGetters({
      getSingleCompany: `companyModule/${companyType.getters.GET_SINGLE_COMPANY}`,
    }),
    naka(): NakaCompanyConfiguration {
      if (this.getSingleCompany.naka_company_configuration) {
        return this.getSingleCompany.naka_company_configuration;
      }
      return {
        registration_number: '',
        exchange_fee_id: '',
        transaction_fee_id: 0,
        mcc: 0,
        business_type: null,
        trr: null,
        website: null,
        number_of_employees: null,
        slogan: null,
        established_at: '',
        fiat_currency_active_id: '',
        fiat_currency_pending_id: '',
        settlement_currency_active_id: '',
        settlement_currency_pending_id: '',
      };
    },
  },
});
